import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { GoalOverviewSubType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import { addMonths, startOfMonth } from "date-fns";
import { format } from "date-fns";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, bool, date, mixed, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type HousingOtherGoalFormType = {
  readonly name: string;
  readonly goalSubType: GoalOverviewSubType;
  readonly targetDate: Date;
  readonly referenceStartDate: Date;
  readonly targetAmount: number;
  readonly monthlyContribution: number;
  readonly monthlyContributionWithFee: number;
  readonly interestRate: number;
  readonly inflationRate: number;
  readonly feeRate: number;
  readonly includeInflation?: boolean;
  readonly includeFee?: boolean;
  readonly note?: string;
  readonly priority?: boolean;
};

export const minDate = startOfMonth(addMonths(new Date(), 1));

export const getHousingOtherFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<HousingOtherGoalFormType> = (t) => {
  return object({
    name: string().required(t(Resources.Validation.Required)),
    goalSubType: mixed<GoalOverviewSubType>().required(t(Resources.Validation.Required)),
    targetAmount: number().required(t(Resources.Validation.Required)),
    targetDate: date()
      .required(t(Resources.Validation.Required))
      .min(minDate, t(Resources.Validation.MustBeOlderThanDate, { date: format(minDate, "dd.MM.yyyy") })),
    referenceStartDate: date().required(t(Resources.Validation.Required)),
    monthlyContribution: number().required(t(Resources.Validation.Required)),
    monthlyContributionWithFee: number().required(t(Resources.Validation.Required)),
    feeRate: number().required(t(Resources.Validation.Required)),
    interestRate: number().required(t(Resources.Validation.Required)),
    inflationRate: number().required(t(Resources.Validation.Required)),
    includeInflation: bool().required(t(Resources.Validation.Required)),
    includeFee: bool().required(t(Resources.Validation.Required)),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
    priority: bool(),
  }).defined();
};
